module.exports={render:function (){with(this) {
  return _h('section', {
    staticClass: "ion-item-group"
  }, [_t("default")])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bed012d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/item/src/item.group.vue
// module id = 162
// module chunks = 0